<template>
  <caption :class="cn('mt-4 text-sm', props.class)">
    <slot />
  </caption>
</template>

<script>
import { cn } from '../../utils.js';

export default {
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return { props, cn };
  },
};
</script>
